import React from 'react';

const PageLoader: React.FC = () => {
  return (
    <div className="fixed inset-0 z-[12000] flex items-center justify-center pointer-events-none">
      <div className="flex flex-col items-center gap-5">
        {/* Logo */}
        <div className="relative flex items-center justify-center">
          <div className="absolute w-28 h-28 sm:w-36 sm:h-36 rounded-full animate-loader-glow" />
          <div className="absolute w-20 h-20 sm:w-24 sm:h-24 rounded-full animate-spin"
            style={{
              border: '2.5px solid transparent',
              borderTopColor: 'rgba(99,102,241,0.5)',
              borderRightColor: 'rgba(139,92,246,0.25)',
            }} />
          <div className="relative w-[68px] h-[68px] sm:w-20 sm:h-20 animate-loader-logo"
            style={{
              filter: 'drop-shadow(0 0 8px rgba(99,102,241,0.4))',
            }}>
            <img src="/logo_dark.png" alt="FinCalc"
              className="w-full h-full object-contain" />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes loader-logo {
          0%, 100% { transform: scale(1); opacity: 0.75; }
          50% { transform: scale(1.08); opacity: 1; }
        }
        @keyframes loader-glow {
          0%, 100% { transform: scale(0.95); opacity: 0.2; }
          50% { transform: scale(1.2); opacity: 0.5; }
        }
        .animate-loader-logo {
          animation: loader-logo 2.4s ease-in-out infinite;
        }
        .animate-loader-glow {
          animation: loader-glow 2.4s ease-in-out infinite;
          background: radial-gradient(circle, rgba(99,102,241,0.15) 0%, transparent 70%);
        }
      `}</style>
    </div>
  );
};

export default PageLoader;
